<div class="error-message" *ngIf="establecimientoError">Selecciona un establecimineto</div>
<div class="ok-message fade-out" *ngIf="dispositivoCreado">El dispositivo se ha editado correctamente</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorFinalMessage}}</div>

<ng-container *ngIf="errorMessage !== ''">
    <div class="error-container">
        <div class="mensaje-error-container">
            <div class="mensaje-error">{{ errorMessage }}</div>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<div class="container" *ngIf="errorMessage === ''">
    <div class="header">
        <div class="header-content">
            <span class="font20">ACTUALIZAR DISPOSITIVO - INSTALACIÓN</span>
            <button mat-icon-button matTooltip="Guardar cambios" class="gurdar-btn" (click)="guardarDispositivo()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario de actualización de dispositivos DataBeer</span>
    </div>
    <div class="body">

        <!--DISPOSITIVO-->
        <div class="datos-dispositivo">
            <div class="datos-dispositivo-header">
                <span>DATOS DEL DISPOSITIVO</span>
            </div>

            <mat-form-field class="etiqueta-container marginTop20">
                <mat-label class="label-text">Nombre de Dispositivo</mat-label>
                <input matInput type="text" [(ngModel)]="etiqueta" placeholder="Nombre de una localidad, parroquia, nucleo, etc..." value="{{this.disopositivoActual.dev_label}}">
                <button *ngIf="etiqueta" matSuffix mat-icon-button aria-label="Clear" (click)="etiqueta=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="descripcion-container">
                <mat-label class="label-text">Descripcion</mat-label>
                <textarea matInput type="text" [(ngModel)]="descripcion" placeholder="Situación actual del depósito" value="{{descripcion}}"></textarea>
                <button *ngIf="descripcion" matSuffix mat-icon-button aria-label="Clear" (click)="descripcion=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <div class="estado-container marginTopM10">
                <span class="titulos-dispositivo">Estado: </span>
                <mat-form-field class="custom">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(ngModel)]="selectedEstado" name="est">
                        <mat-option *ngFor="let est of estado" [value]="est.value">
                        {{est.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="marginBottom20">
                <mat-checkbox [(ngModel)]="configuracionFinalizada" color="warn" class="marginLeftM10">
                    <span class="custom1">Configuración del dispositivo finalizada</span>
                </mat-checkbox>
            </div>

            <div class="referencia-container">
                <span class="titulos-dispositivo">Referencia: </span><span> Código DBXXX del dispositivo</span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [readonly]="true" value={{disopositivoActual.dev_reference}}/>
                </mat-form-field>
            </div>

            <div class="token-container">
                <span class="titulos-dispositivo">Token de seguridad: </span><span> Cadena única de acceso seguro al dispositivo</span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [(ngModel)]="tokenSeguridad" [readonly]="true" value={{tokenSeguridad}}/>
                </mat-form-field>
            </div>

            <!--<div class="mode-version-container">
                <span class="titulos-dispositivo">Modelo - Versión: </span><span> Modelo y versión del dispositivo</span>
                <mat-form-field style="width: 100%; margin-top: 10px;">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [disabled]="true" [(ngModel)]="selectedVersion" name="modVer">
                        <mat-option *ngFor="let modVer of modeloVersion" [value]="modVer.value">
                        {{modVer.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>-->

            <mat-form-field class="etiqueta-container marginTop0" appearance="outline">
                <mat-label class="titulos-dispositivo">Nº de serie</mat-label>
                <input matInput type="text" [(ngModel)]="numSerie" placeholder="Ejemplo: VI1807160530V22" [readonly]="true">
            </mat-form-field>

            <mat-form-field class="etiqueta-container marginTop0" appearance="outline">
                <mat-label class="titulos-dispositivo">Nº SIM</mat-label>
                <input matInput type="text" [(ngModel)]="nSIM" placeholder="Ejemplo: 18071605300000 000 0" [readonly]="true">
            </mat-form-field>

            <mat-form-field class="etiqueta-container marginTop0" appearance="outline">
                <mat-label class="titulos-dispositivo">Versión</mat-label>
                <input matInput type="text" [(ngModel)]="version" placeholder="Versión del dispositivo" [readonly]="true">
            </mat-form-field>

            <!--<div class="caracteristicas-container">
                <span class="titulos-dispositivo">Características: </span><span> Activar las opciones especiales del dispósitivo</span>
                <div class="multitanque-container marginTop10">
                    <section class="example-section">
                        <mat-checkbox class="example-margin" [(ngModel)]="multitanque" color="warn">Multitanque</mat-checkbox>
                    </section>
                </div>
                <div class="tanques-container">
                    <div class="tanques-activados-container" *ngIf="multitanque">
                        <span class="titulos-dispositivo">Activar tanques</span>
                        <div class="tanques-activados" *ngIf="multitanque">
                            <section class="tanque">
                                <mat-checkbox
                                    class="example-margin"
                                    [(ngModel)]="checkedT1"
                                    [disabled]="!multitanque"
                                    color="warn">
                                Tanque 1
                                </mat-checkbox>
                            </section>
                            <section class="tanque">
                                <mat-checkbox
                                    class="example-margin"
                                    [(ngModel)]="checkedT2"
                                    [disabled]="!multitanque"
                                    color="warn">
                                Tanque 2
                                </mat-checkbox>
                            </section>
                            <section class="tanque">
                                <mat-checkbox
                                    class="example-margin"
                                    [(ngModel)]="checkedT3"
                                    [disabled]="!multitanque"
                                    color="warn">
                                Tanque 3
                                </mat-checkbox>
                            </section>
                        </div>
                    </div>
                    <div class="tanques-capacidad-container" *ngIf="multitanque">
                        <div class="capacidad-titulo">
                            <span class="titulos-dispositivo">Capacidad individual (litros)</span>
                        </div>
                        <mat-form-field color="warn" style="margin-top: 24px; width: 65%;">
                            <mat-label>Tanque 1</mat-label>
                            <input matInput placeholder="Litros Tanque 1" [disabled]="!checkedT1" [(ngModel)]="valorTanque1">
                        </mat-form-field>
                        <mat-form-field class="tanque-input" color="warn">
                            <mat-label>Tanque 2</mat-label>
                            <input matInput placeholder="Litros Tanque 2" [disabled]="!checkedT2" [(ngModel)]="valorTanque2">
                        </mat-form-field>
                        <mat-form-field class="tanque-input" color="warn">
                            <mat-label>Tanque 3</mat-label>
                            <input matInput placeholder="Litros Tanque 3" [disabled]="!checkedT3" [(ngModel)]="valorTanque3">
                        </mat-form-field>
                    </div>
                </div>
            </div>-->

            <!--<section class="tanque">
            <mat-checkbox
                    class="example-margin"
                    [(ngModel)]="checkedT4"
                    [disabled]="!multitanque"
                    color="warn">
                Tanque 4
                </mat-checkbox>
            </section>-->

        <!--<mat-form-field class="tanque-input" color="warn">
            <mat-label>Tanque 4</mat-label>
            <input matInput placeholder="Litros Tanque 4" [disabled]="!checkedT4" [(ngModel)]="valorTanque4">
        </mat-form-field>-->
        </div>
                
        <!--INSTALACION-->
        <div class="datos-instalacion">
            <div class="datos-instalacion-header">
                <span>DATOS DE LA INSTALACIÓN</span>
            </div>

            <!--<div style="margin-top: 20px;">
                <span class="custom3">Establecimiento: * </span>
                <mat-form-field style="width: 100%; margin-top: 10px;">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedEstablecimiento" name="est" (selectionChange)="updateEstadoErrorEstablecimiento()">
                      <mat-option *ngFor="let est of establecimientos" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>-->

            <div class="custom2">
                <span class="custom3" [ngClass]="{'error-select': establecimientoError}">Establecimiento: * </span>
                <form class="custom4">
                    <mat-form-field class="widht100">
                        <mat-label>Establecimiento</mat-label>
                        <input type="text"
                                placeholder="Elige uno"
                                aria-label="Establecimiento"
                                matInput
                                [formControl]="myControl"
                                [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <button *ngIf="myControl.value != ''" matSuffix mat-icon-button aria-label="Clear" (click)="limpiarSeleccion()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="establecimientoError" class="custom5">Selecciona un establecimiento</mat-error>
                </form>
            </div>

            <div>
                <div class="marginBottom20">
                    <span class="custom3">Ubicación del establecimiento: </span>
                </div>
                <div id="map" class="height450"></div>
            </div>

            <div class="referencia-container marginTop20">
                <span class="custom3">Dirección completa: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="addressData">
                    <input matInput type="text" [readonly]="true" value="{{addressData}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="!addressData">
                    <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                </mat-form-field>
            </div>

            <mat-form-field class="lat-container width48" appearance="outline">
                <mat-label class="label-text">Latitud</mat-label>
                <input matInput type="number" [(ngModel)]="lat" [readonly]="true" placeholder="Selecciona la latitud" value="{{lat}}">
            </mat-form-field>

            <mat-form-field class="lng-container custom6" appearance="outline">
                <mat-label class="label-text">Longitud</mat-label>
                <input matInput type="number" [(ngModel)]="lng" [readonly]="true" placeholder="Selecciona la latitud" value="{{lng}}">
            </mat-form-field>

            <div class="clientes-container" *ngIf="userData.pro_id == 4">
                <span class="titulos-dispositivo">Cliente: </span><span> Ejemplo: DATAMONITORING SL</span>
                <mat-form-field class="custom7">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(ngModel)]="selectedCliente" name="clt">
                        <mat-option *ngFor="let clt of clientes" [value]="clt.value">
                        {{clt.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!--<div class="acceso-usuarios">
            <div class="acceso-usuarios-header">
                <span>ACCESO USUARIOS</span>
            </div>
            <div class="usuarios-añadir-email">
                <mat-form-field class="email-input">
                    <mat-label class="titulos-dispositivo">email de usuario</mat-label>
                    <input matInput type="text" [(ngModel)]="usuarioEmail" placeholder="nombre@ejemplo.com">
                    <button *ngIf="usuarioEmail" matSuffix mat-icon-button aria-label="Clear" (click)="usuarioEmail=''">
                        <mat-icon>close</mat-icon>
                      </button>
                </mat-form-field>
                <button mat-raised-button color="warn" class="btn-añadir">Añadir</button>
            </div>

            <div class="top-container">
                <mat-form-field>
                    <mat-label style="color: rgb(0, 0, 0);">Filtrar</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
                </mat-form-field>
            </div>

            <div class="tabla">
                <table mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Login </th>
                        <td mat-cell *matCellDef="let element" class="login-cell"> {{element.email}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="operaciones">
                        <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                        <td mat-cell *matCellDef="let element" class="operacion-cell">
                            <button mat-button color="warn" style="transform: translateY(-20%); margin-top: 15px;" (click)="removeEmail(element.email)">Quitar</button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <mat-paginator 
                    [pageSizeOptions]="[5, 10, 20]" 
                    showFirstLastButtons 
                    aria-label="Elige una página"
                    style="width: 100%; font-size: 10px; margin-top: 20px;">
                </mat-paginator>
            </div>
        </div>-->
    </div>
</div>
<div class="footer"></div>